module.exports = __webpack_public_path__ + "static/media/blackrock-further.cc9a2047.png";